import { getFeatureFlag, isBoolean } from "@sinch/feature-flags";
import { useMemo } from "react";
import { useUser } from "../user-context";
import { useLocalStorage } from "../utils";

export const INBOX_LOCAL_STORAGE_CONFIG_KEY = "INBOX_NGI_SELECTED_USER_IDS";

export const INBOX_V2_VERSION = "v2";
export const INBOX_V4_VERSION = "v4";

export type InboxVersion = typeof INBOX_V2_VERSION | typeof INBOX_V4_VERSION;

export type InboxConfig = {
  inboxVersion: InboxVersion;
};

export const useInboxConfig: () => InboxConfig = () => {
  const user = useUser();
  const isV4FFEnabled = getFeatureFlag("inboxV4", isBoolean, false);

  const [userIdsInV4] = useLocalStorage(
    INBOX_LOCAL_STORAGE_CONFIG_KEY,
    (x: unknown): x is string[] => typeof x === "object",
    []
  );

  const inboxVersion = useMemo(() => {
    if (!isV4FFEnabled) {
      return INBOX_V2_VERSION;
    }

    if (userIdsInV4.includes(user.id)) {
      return INBOX_V4_VERSION;
    }
    return INBOX_V2_VERSION;
  }, [isV4FFEnabled, user, userIdsInV4]);

  return {
    inboxVersion,
  };
};
